import { FC } from 'react'

interface CaretRightProps {
  width: number
  height: number
}

const CaretRight: FC<CaretRightProps> = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.292893 2.12129C-0.0976308 1.73077 -0.0976308 1.0976 0.292893 0.707078C0.683418 0.316554 1.31658 0.316553 1.70711 0.707078L8.29289 7.29286C8.68342 7.68339 8.68342 8.31655 8.29289 8.70708L1.70711 15.2929C1.31658 15.6834 0.683418 15.6834 0.292893 15.2929C-0.097631 14.9023 -0.0976311 14.2692 0.292893 13.8787L6.17157 7.99997L0.292893 2.12129Z"
        fill="#212721"
      />
    </svg>
  )
}

export default CaretRight
